import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@photo-booth/ui/button";
import { analyticsClick } from "@/lib/analytics/props";

interface Props {
  prevUrl: string;
}
export const BackButton: React.FC<Props> = ({ prevUrl }) => {
  const navigate = useNavigate();
  return (
    <div className="px-8">
      <Button
        variant="ghost"
        onClick={() => navigate(prevUrl)}
        {...analyticsClick({ event: "back-button", feature: "ui", location: window.location.pathname })}
      >
        <ArrowLeftIcon className="w-4 h-4" />
        Back
      </Button>
    </div>
  );
};
